export default __webpack_public_path__ + "static/media/bridal1.ff45e57d.jpg";